export enum BuildEnvironments {
  DEV = 'DEV',
  PROD = 'PROD'
}

export class EnvironmentSettings {
  public static readonly BUILD_ENVIRONMENT: string = BuildEnvironments.DEV;
}